export interface MaterialTextureRepeatSource {
  textile_repeat_multiplier?: number
  texture?: { id?: number } | null
}

export function getMaterialTextureRepeatMultiplier(
  textures: MaterialTextureRepeatSource[] | undefined,
  options?: { textureId?: number | null; index?: number },
): number {
  if (!textures?.length) return 1.0

  if (
    options?.index != null &&
    textures[options.index]?.textile_repeat_multiplier != null
  ) {
    return textures[options.index].textile_repeat_multiplier!
  }

  if (options?.textureId != null) {
    const match = textures.find((entry) => entry.texture?.id === options.textureId)
    if (match?.textile_repeat_multiplier != null) {
      return match.textile_repeat_multiplier
    }
  }

  if (textures[0]?.textile_repeat_multiplier != null) {
    return textures[0].textile_repeat_multiplier
  }

  return 1.0
}
